/**
 * Font stack presets with Google Fonts integration
 */

export interface FontStack {
  name: string;
  value: string;
  body: string;
  display: string;
  googleFontsHref: string;
  description: string;
}

export const fontStacks: Record<string, FontStack> = {
  system: {
    name: 'System (Standard)',
    value: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    body: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    display: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    googleFontsHref: '',
    description: 'Schnell, DSGVO-freundlich, robust',
  },
  serif: {
    name: 'Serif (Klassisch)',
    value: "Georgia, 'Times New Roman', serif",
    body: "Georgia, 'Times New Roman', serif",
    display: "Georgia, 'Times New Roman', serif",
    googleFontsHref: '',
    description: 'Klassisch, elegant',
  },
  mono: {
    name: 'Monospace',
    value: "'SF Mono', Monaco, 'Cascadia Code', monospace",
    body: "'SF Mono', Monaco, 'Cascadia Code', monospace",
    display: "'SF Mono', Monaco, 'Cascadia Code', monospace",
    googleFontsHref: '',
    description: 'Tech, Developer',
  },
  spark: {
    name: 'Spark (Fraunces + Plus Jakarta Sans)',
    value: "'Plus Jakarta Sans', system-ui, -apple-system, sans-serif",
    body: "'Plus Jakarta Sans', system-ui, -apple-system, sans-serif",
    display: "'Fraunces', ui-serif, Georgia, serif",
    googleFontsHref:
      'https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,400..700&family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap',
    description: 'Premium-Modern (FutSure/Spark Look)',
  },
  instrument: {
    name: 'Instrument Sans (Swiss Clean)',
    value: "'Instrument Sans', system-ui, -apple-system, sans-serif",
    body: "'Instrument Sans', system-ui, -apple-system, sans-serif",
    display: "'Instrument Sans', system-ui, -apple-system, sans-serif",
    googleFontsHref:
      'https://fonts.googleapis.com/css2?family=Instrument+Sans:wght@400;500;600;700&display=swap',
    description: 'Klar, technisch, pr\u00e4zise (City/Industrial Look)',
  },
  dmsans: {
    name: 'DM Sans (Warm Modern)',
    value: "'DM Sans', system-ui, -apple-system, sans-serif",
    body: "'DM Sans', system-ui, -apple-system, sans-serif",
    display: "'DM Sans', system-ui, -apple-system, sans-serif",
    googleFontsHref:
      'https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap',
    description: 'Warm, modern (Holzbau Look)',
  },
  dmserif: {
    name: 'DM Serif + Source Sans 3 (Editorial Corporate)',
    value: "'Source Sans 3', system-ui, -apple-system, sans-serif",
    body: "'Source Sans 3', system-ui, -apple-system, sans-serif",
    display: "'DM Serif Display', ui-serif, Georgia, serif",
    googleFontsHref:
      'https://fonts.googleapis.com/css2?family=DM+Serif+Display&family=Source+Sans+3:wght@400;600;700&display=swap',
    description: 'Editorial + Corporate (GVB Look)',
  },
  inter: {
    name: 'Inter (Product Minimal)',
    value: "'Inter', system-ui, -apple-system, sans-serif",
    body: "'Inter', system-ui, -apple-system, sans-serif",
    display: "'Inter', system-ui, -apple-system, sans-serif",
    googleFontsHref:
      'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap',
    description: 'Neutral, produktig, minimal (Strain Look)',
  },
};
